module.exports = __webpack_public_path__ + "img/converted.14fcdee5.png";